import styled from 'styled-components';

export const QPopupBox = styled.div`
  padding: 4px;
  position: fixed;
  font-size: 14px;
  line-height: 20px;
  z-index: 2;
  border: solid;
  border-width: 1px;
  margin-left: -1px;
  color: ${({ theme }) => theme.palette.text.secondary};
  background: ${({ theme }) => theme.palette.surface.overlay};
  border-color: ${({ theme }) => theme.palette.text.strong};
`;

export const MenuItem = styled.div`
  color: ${({ theme }) => theme.palette.text.strong};
  background: ${({ theme }) => theme.palette.surface.overlay};
  &.active {
    &:hover {
      background: ${({ theme }) => theme.palette.state.hover.default};
    }
    &:active {
      background: ${({ theme }) => theme.palette.state.hover.default};
    }
  }
`;

export const HiddenInput = styled.input`
  position: fixed;
  height: 2px;
  width: 2px;
  opacity: 0;
`;

export const Separator = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.palette.text.tertiary};
  margin-top: 2px;
  margin-bottom: 2px;
  height: 2px;

`;
